import styled, { css } from 'styled-components';
export const Container = styled.li`
  display: flex;
  width: 100%;
  min-width: 800px;
  gap: 1rem;
  padding: .5rem;
  align-items: center;
  background-color: #ffffff;
  border-radius: 4px 0 0 4px;
  border-bottom: solid 1px #dadce0;
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  > div:nth-child(1){
    display: flex;
    width: calc(100% - 3rem);
    min-height: 2.5rem;
    flex-direction: row;
    > div:nth-child(1){
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 4rem;
      min-width: 20%;

      @media (min-width: 1000px) {
        flex: none;
      }
    }
    > div:nth-child(2){
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex: 10rem;
      min-width: 30%;
      border-left: 2px solid #ecedef;
      padding-left: 10px;

      @media (min-width: 1500px) {
        flex: 5rem;
      }
    }
    > div:nth-child(3) {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex: 22rem;
      width: 100%;
      border-left: 2px solid #ecedef;
      padding-left: 10px; 
      padding-right: 10px;
      > div {
        max-height: 5rem;
        width: 40rem;
        max-width: 40rem;;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }  
    }
    
    @media (max-width: 1470px) {
      > div:nth-child(3) {
        > div {
          width: 26rem;
          max-width: 26rem;
        }
      }
    }
    
    @media (max-width: 768px) {
      > div:nth-child(3) {
        > div {
          width: 20rem;
          max-width: 20rem;
        }
      }
    }
  }
  > div:nth-child(2){
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    min-height: 100%;
    cursor: pointer;
    > span {
      display: flex;
      width: 3rem;
      height: 3rem;
      justify-content: center;
      align-items: center;
      background: #ecedef;
      border-radius: 6px;
      &:hover{
        opacity: 0.9;
      }
      > .user-settings {
        font-size: 1.5rem;
        color: #1D86FF;
      }
    }
  }
`;